/**
 * Created by zhoulong on 2019/7/3.
 */

import Cookies from 'js-cookie'

export function storeConfig() {
    Cookies.set('VUE_APP_BASE_API', process.env.VUE_APP_BASE_API)
    Cookies.set('VUE_APP_LOGOUT', process.env.VUE_APP_LOGOUT)
    // Cookies.set('VUE_APP_WS_URL', process.env.VUE_APP_WS_URL)
    // Cookies.set('VUE_APP_WS_CONTEXT', process.env.VUE_APP_WS_CONTEXT)
    Cookies.set('VUE_APP_OAUTH_URL', process.env.VUE_APP_OAUTH_URL)
    Cookies.set('VUE_APP_CLIENT_ID', process.env.VUE_APP_CLIENT_ID)
    Cookies.set('VUE_APP_CLIENT_SECRET', process.env.VUE_APP_CLIENT_SECRET)
    Cookies.set('VUE_APP_WEBAPP_URL', process.env.VUE_APP_WEBAPP_URL)
    Cookies.set('VUE_APP_MONITOR_URL', process.env.VUE_APP_MONITOR_URL)
    Cookies.set('APP_HELP_DOC_URL', process.env.APP_HELP_DOC_URL)
}

export const globalConfig = {
    VUE_APP_BASE_API: Cookies.get('VUE_APP_BASE_API'),
    VUE_APP_LOGOUT: Cookies.get('VUE_APP_LOGOUT'),
    // VUE_APP_WS_URL: Cookies.get('VUE_APP_WS_URL'),
    // VUE_APP_WS_CONTEXT: Cookies.get('VUE_APP_WS_CONTEXT'),
    VUE_APP_OAUTH_URL: Cookies.get('VUE_APP_OAUTH_URL'),
    VUE_APP_CLIENT_ID: Cookies.get('VUE_APP_CLIENT_ID'),
    VUE_APP_CLIENT_SECRET: Cookies.get('VUE_APP_CLIENT_SECRET'),
    VUE_APP_WEBAPP_URL: Cookies.get('VUE_APP_WEBAPP_URL'),
    VUE_APP_MONITOR_URL: Cookies.get('VUE_APP_MONITOR_URL'),
    APP_HELP_DOC_URL: Cookies.get('APP_HELP_DOC_URL'),
}